import { useTranslation } from "react-i18next";
import {
  GROUP_KINDS,
  capForGroupKind,
} from "../../utils/groupKind";

const LABEL_KEY = {
  training: "groupKindTraining",
  championship: "groupKindChampionship",
  ping_sante_bien_etre: "groupKindPingSante",
  ping_sante_prescription: "groupKindPrescription",
};

export function GroupKindFields({ kind, guestCoachName, onKind, onGuest }) {
  const { t } = useTranslation();
  const cap = capForGroupKind(kind);
  return (
    <div className="eg-kind-fields">
      <div className="eg-field">
        <label htmlFor="group-kind">{t("groupKind", "Group type")}</label>
        <select
          id="group-kind"
          className="eg-select"
          value={kind || "training"}
          onChange={(event) => onKind(event.target.value)}
        >
          {GROUP_KINDS.map((id) => (
            <option key={id} value={id}>
              {t(LABEL_KEY[id])}
            </option>
          ))}
        </select>
        {cap ? (
          <p className="eg-hint">
            {t("groupKindCap", "At most {{cap}} players in this group.", { cap })}
          </p>
        ) : null}
      </div>
      <div className="eg-field">
        <label htmlFor="group-guest-coach">
          {t("groupGuestCoach", "Visiting coach (not a club admin)")}
        </label>
        <input
          id="group-guest-coach"
          className="eg-input"
          type="text"
          maxLength={120}
          value={guestCoachName || ""}
          placeholder={t(
            "groupGuestCoachHint",
            "Name only. This does not grant admin access."
          )}
          onChange={(event) => onGuest(event.target.value)}
        />
      </div>
    </div>
  );
}
